import React from "react";
import { FormField, Input, ErrorMessage, InfoIcon } from "@vwfs-bronson/bronson-react";
import { getIn } from "formik/dist/index";

export function TextField({
  field: { onChange, onBlur, name, ...field },
  form: { setFieldValue, errors, touched },
  normalizeOnChange,
  customOnChange,
  normalize,
  label,
  tooltip,
  notion,
  ...props
}) {
  const error = getIn(touched, name) && getIn(errors, name);

  const id = props.id || name;

  const handleChange = (ev) => {
    if (customOnChange) {
      customOnChange(ev);
    } else if (!normalizeOnChange) {
      onChange(ev);
    } else {
      const normOnChange = ({ target: { name, value } }) => {
        onChange({
          target: { name, value: normalize ? normalize(value) : value },
        });
      };
      normOnChange(ev);
    }
  }

  const handleBlur = normalizeOnChange
    ? onBlur
    : ({ target: { name, value } }) => {
        setFieldValue(name, normalize ? normalize(value) : value, false);
        return onBlur({ target: { name } });
      };
  return (
    <FormField
      type={field.type || "other"}
      labelText={label}
      id={id}
      infoIcon={tooltip && <InfoIcon icon="semantic-info">{tooltip}</InfoIcon>}
      notion={notion}
      errorMessage={error ? <ErrorMessage id={id}>{error}</ErrorMessage> : null}
      labelElement="div"
      noFloatingLabel
    >
      <Input
        {...props}
        {...field}
        name={name}
        id={id}
        onBlur={handleBlur}
        onChange={handleChange}
        {...field}
        error={!!error}
      />
    </FormField>
  );
}
